<template>
	<div class="page">
		<div class="container">
			<div class="notes">Which of the following best describes your business</div>
			<div class="content">
				<!-- <ul class="list">
					<li v-for="(item, index) in data.list" :key="index" :style="{color: data.selected === item.id ? style.mainColor : '' }" @click="choose(item.id)">{{item.en_name}}</li>
				</ul> -->
				<van-collapse v-model="activeNames" class="radius">
					<template v-for="(item, index) in data.list">
						<van-collapse-item v-if="item.children" :key="item.id" :name="item.id">
							<template #title>
								<div class="flex justify-center industry-item" :style="{border: index === 0 ? 'none' : ''}">
									{{item.en_name}}
								</div>
							</template>
							<template #default>
								<div v-for="(e) in item.children" :key="e.id" class="sub-item" :style="{color: data.selected == e.id ? style.mainColor : '#9F9D9D' }" @click="choose(e.id)">
									{{e.en_name}}
								</div>
							</template>
						</van-collapse-item>
						<div v-else :key="item.id" class="industry-item" :style="{color: data.selected == item.id ? style.mainColor : '' }" @click="choose(item.id)">
							{{item.en_name}}
						</div>
					</template>
				</van-collapse>
			
      </div>
		</div>
		<div class="footer">
			<bottom :mode="style.mode" :level="style.level" language="en"></bottom>
		</div>
	</div>
</template>

<script>
	import commonMixin from '@/view/process/mixin/common.js'
	import industrySelectMixin from '@/view/process/mixin/industrySelect.js'

	export default {
		mixins: [commonMixin, industrySelectMixin],
		data() {
			return {
				
			}
		},
		created() {
			this.setLanguge('en'); // 设置语言环境
		},
		methods: {
			
		},
	}
</script>

<style lang="less" scoped>
	@color: #9F9D9D;
	
	.notes {
		margin: 5vh auto 4vh;
		text-align: center;
		font-size: 22px;
		font-weight: bold;
		color: @color;
		font-family: 'DIN-Medium';
	}
	
	.content {
		
		/deep/ .van-collapse {
			background-color: #fff;
			width: 300px;
			margin: 0 auto;
			
			.van-cell {
			  padding: 0;
				align-items: center;
			}
			.van-cell::after {
			    border-bottom: none;
			}
			.van-icon {
				position: absolute;
				top: 19px;
				right: 12px;
			}
			
			.van-collapse-item__content {
				padding: 0;
				margin-top: -5px;
				margin-bottom: 5px;
			}
			
			.van-collapse-item--border::after {
				border-top: none;
			}
			
		}
		
		.industry-item {
			margin: 0 15px;
		  font-size: 14px;
		  min-height: 60px;
		  line-height: 25px;
		  text-align: center;
		  letter-spacing: 1Px;
		  font-family: Source Han Sans CN;
		  font-weight: bold;
			border-top: 1Px solid #e0e0e0;
			word-break: break-all;
			display: flex;
			align-items: center;
			justify-content: center;
		}
		
		.sub-item {
		  text-align: center;
		  font-size: 14px;
			// height: 50px;
		  line-height: 50px;
		  font-family: Source Han Sans CN;
		  font-weight: 400;
		}
		
	}

	.list {
		width: 240px;
		margin: 0 auto;
		background-color: #fff;
		padding: 10px 20px;
		border-radius: 8px;

		li {
			color: #333;
			text-align: center;
			font-size: 20px;
			// height: 55px;
			line-height: 37px;
			font-family: 'DIN-Regular';
			word-break: break-word;
			
			display: flex;
			justify-content: center;
			align-items: center;
			padding: 11px 0;
		}

		li+li {
			border-top: 1PX solid #ddd;
		}
	}
</style>
